import { FC } from "react";
import { useDispatch } from "react-redux";

import { UserTravelVisaForm } from "Bands/components";
import { createUserTravelVisa, dispatchGetUserTravelVisas } from "Bands/state";
import { IUserTravelVisaPatchData, USER_ACTIONS } from "Bands/types";
import { copy } from "shared/assets";
import { IFormButtons } from "shared/types";
import { UserEntityModal } from "Bands/containers";
import { Passport } from "shared/assets/icons";

const { userTravelVisa: visaCopy } = copy;

interface Props {
  handleClose: () => void;
}

export const CreateUserTravelVisaModal: FC<Props> = ({ handleClose }) => {
  const dispatch = useDispatch();

  const buttons: IFormButtons = {
    primary: {
      children: visaCopy.buttons.create,
    },
    secondary: {
      onClick: handleClose,
    },
  };

  const handleSubmit = (data: IUserTravelVisaPatchData) => {
    dispatch(createUserTravelVisa(data));
  };

  const handleSuccess = () => {
    dispatchGetUserTravelVisas(dispatch);
  };

  return (
    <UserEntityModal
      title={visaCopy.create.title}
      icon={Passport}
      action={USER_ACTIONS.createUserTravelVisa}
      buttons={buttons}
      successMessage={visaCopy.messages.created}
      Component={UserTravelVisaForm}
      handleSubmit={handleSubmit}
      handleClose={handleClose}
      handleSuccess={handleSuccess}
    />
  );
};
